import React, { useEffect, useState } from "react"

const Loading = props => {
  const [imgCount, addImgCount] = useState(0)
  const setLoad = props.setLoad
  const loader = require("../../images/other/loader.gif")

  // PreLoad
  const preLoadList = []
  preLoadList.push(require("../../images/gratz/01.png"))
  preLoadList.push(require("../../images/gratz/02.png"))
  preLoadList.push(require("../../images/gratz/03.png"))
  preLoadList.push(require("../../images/gratz/04.png"))
  preLoadList.push(require("../../images/gratz/ume01.png"))
  preLoadList.push(require("../../images/gratz/ume02.png"))
  preLoadList.push(require("../../images/gratz/ume03.png"))
  preLoadList.push(require("../../images/gratz/ume04.png"))

  useEffect(() => {
    var tmpCount = 0
    preLoadList.map(element => {
      const tmpImg = new Image()
      tmpImg.src = element
      tmpImg.onload = () => {
        tmpCount += 1
        addImgCount(tmpCount)
      }
    })
  }, [])
  if (imgCount === 8) {
    setTimeout(() => setLoad(false), 500)
  }
  return (
    <div id="loader-wrap">
      <img id="loader" src={loader} alt="loader" />
    </div>
  )
}

export default Loading
